import api from "../utils/api";
import { normalizeIeltsReadingData } from "./normalizeIeltsReading";
import { normalizeIeltsListeningData } from "./normalizeIeltsListening";

// Simpan data identity
export const storeIdentity = async (data) => {
  try {
    // console.log("Mengirim identity:", data);
    const res = await api.post("/identity/store", data);
    // console.log("Response storeIdentity:", res);
    return res;
  } catch (err) {
    console.error(
      "Error storeIdentity:",
      err.response?.status,
      err.response?.data || err.message,
    );
    throw err;
  }
};

export const login = async (data) => {
  try {
    const res = await api.post("/login", data);
    return res.data;
  } catch (err) {
    console.error(
      "Error login:",
      err.response?.status,
      err.response?.data || err.message,
    );
    throw err;
  }
};

// Ambil soal + option
export const getQuestions = async () => {
  try {
    // console.log(
    //   "Memulai getQuestions, token:",
    //   localStorage.getItem("token") || "Kosong"
    // );
    const res = await api.get("/placeman/questions?all=true");
    // console.log("Response getQuestions:", res.data);
    return res.data.question || [];
  } catch (err) {
    console.error(
      "Error getQuestions:",
      err.response?.status,
      err.response?.data || err.message,
    );
    throw err;
  }
};

// Kirim jawaban test
export const submitAnswer = async ({ question_id, option_id }) => {
  const identity_id = localStorage.getItem("identity_id");
  try {
    // console.log("Mengirim jawaban:", { question_id, option_id, identity_id });
    const res = await api.post("/placeman/test/answer", {
      identity_id,
      question_id,
      selected_option_id: option_id,
    });
    // console.log("Response submitAnswer:", res.data);
    return res.data;
  } catch (err) {
    console.error(
      "Error submitAnswer:",
      err.response?.status,
      err.response?.data || err.message,
    );
    throw err;
  }
};

// Ambil hasil test
export const getTestResult = async () => {
  const identity_id = localStorage.getItem("identity_id");
  try {
    // console.log("Mengambil hasil tes, identity_id:", identity_id);
    const res = await api.get(
      `/placeman/test/result?identity_id=${identity_id}`,
    );
    // console.log("Response getTestResult:", res.data);
    return res.data;
  } catch (err) {
    console.error(
      "Error getTestResult:",
      err.response?.status,
      err.response?.data || err.message,
    );
    throw err;
  }
};

// Ambil soal ietls + option
export const getIetlsReadingQuestions = async () => {
  try {
    // console.log(
    //   "Memulai getQuestions, token:",
    //   localStorage.getItem("token") || "Kosong"
    // );
    const res = await api.get("/ielts/questions");
    // console.log("Response getQuestions:", res.data);
    return normalizeIeltsReadingData(res.data) || [];
  } catch (err) {
    console.error(
      "Error getQuestions:",
      err.response?.status,
      err.response?.data || err.message,
    );
    throw err;
  }
};

// Kirim jawaban test
export const submitIetlsReadingAnswer = async (answers) => {
  const identity_id = localStorage.getItem("identity_id");
  try {
    // console.log("Mengirim jawaban:", { answers, identity_id });
    const res = await api.post("/ielts/submit-answers", {
      user_id: identity_id,
      answers: answers,
    });
    // console.log("Response submitAnswer:", res.data);
    return res.data;
  } catch (err) {
    console.error(
      "Error submitAnswer:",
      err.response?.status,
      err.response?.data || err.message,
    );
    throw err;
  }
};

// Ambil soal ietls + option
export const getIetlsListeningQuestions = async () => {
  try {
    // console.log(
    //   "Memulai getQuestions, token:",
    //   localStorage.getItem("token") || "Kosong"
    // );
    const res = await api.get("/ielts/listening/questions");
    // console.log("Response getQuestions:", res.data);
    return normalizeIeltsListeningData(res.data) || [];
  } catch (err) {
    console.error(
      "Error getIetlsListeningQuestions:",
      err.response?.status,
      err.response?.data || err.message,
    );
    throw err;
  }
};

// Kirim jawaban test
export const submitIetlsListeningAnswer = async (answers) => {
  const identity_id = localStorage.getItem("identity_id");
  try {
    // console.log("Mengirim jawaban:", { answers, identity_id });
    const res = await api.post("/ielts/listening/submit-answers", {
      user_id: identity_id,
      answers: answers,
    });
    // console.log("Response submitAnswer:", res.data);
    return res.data;
  } catch (err) {
    console.error(
      "Error submitAnswer:",
      err.response?.status,
      err.response?.data || err.message,
    );
    throw err;
  }
};

export const getScholarships = async (type = "") => {
  try {
    const query = type ? `?type=${type}` : "";
    const res = await api.get(`/scholarships${query}`);
    return res.data?.data || [];
  } catch (err) {
    console.error(
      "Error getScholarships:",
      err.response?.status,
      err.response?.data || err.message,
    );
    throw err;
  }
};

export const getReadinessPlacementResult = async (placementResultId) => {
  try {
    const res = await api.get(`/readiness-checker/placement-result/${placementResultId}`);
    return res.data;
  } catch (err) {
    console.error(
      "Error getReadinessPlacementResult:",
      err.response?.status,
      err.response?.data || err.message,
    );
    throw err;
  }
};

export const submitReadinessChecker = async (payload) => {
  try {
    const res = await api.post("/readiness-checker/submit", payload);
    return res.data;
  } catch (err) {
    console.error(
      "Error submitReadinessChecker:",
      err.response?.status,
      err.response?.data || err.message,
    );
    throw err;
  }
};

export const getReadinessReport = async (sessionId) => {
  try {
    const res = await api.get(`/readiness-checker/${sessionId}/report`);
    return res.data;
  } catch (err) {
    console.error(
      "Error getReadinessReport:",
      err.response?.status,
      err.response?.data || err.message,
    );
    throw err;
  }
};